<div class="form-group" [ngClass]="field.customClass" tabindex="0">
  <label class="mb-1">
    <span>{{ field.label }}</span>
    <span class="text-danger">{{ field.required ? "*" : "" }}</span>
  </label>
  <div>
    @for (opt of options; track opt.key) {
      <div class="form-check" [class.custom-control-inline]="field.inline">
        <input
          type="radio"
          [id]="'opt' + field.name + opt.key"
          [name]="field.name"
          [value]="opt.key"
          [formControl]="control"
          class="form-check-input"
          [attr.disabled]="disabled || null"
        />
        <label class="form-check-label" [for]="'opt' + field.name + opt.key">
          {{ opt.value }}
        </label>
      </div>
    }
  </div>
</div>
